import React from 'react';
import { Field } from 'redux-form';
import { useSelector } from 'react-redux';
import LeadSourcesAutocomplete from '../../Account/LeadSource/LeadSourcesAutocomplete';
import { saveFromCreateNewCustomer, interactFromCreateNewCustomer, trackClearedFromCreateNewCustomer } from '../../Account/LeadSource/Actions';
import { useDataFetcherV2 } from '../../Common/Data/useDataFetcher';
import { canUseLeadSource, fetchOrganizationFeatures } from '../../../Resources/Organization/Features/FeaturesData';

const LeadSourceField = () => {
  useDataFetcherV2(fetchOrganizationFeatures);
  const hasLeadSourceFeature = useSelector(canUseLeadSource);

  if (!hasLeadSourceFeature) return null;
  return (
    <Field
      name="lead_source"
      label="Lead source"
      component={LeadSourcesAutocomplete}
      trackSave={saveFromCreateNewCustomer}
      trackInteract={interactFromCreateNewCustomer}
      trackCleared={trackClearedFromCreateNewCustomer}
    />
  );
};

export default LeadSourceField;
